import axios from "axios";
import { toast } from "react-toastify";

import {
  FileExportExperienceFrontendRequestBodyType,
  FileExportExperienceResponseBodyType,
  FileExportType,
} from "@intelligems/ig-types";
import { TinybirdExperimentAnalysisInput } from "@src/api/analytics/types";
import { useBuildTinybirdPayload } from "@src/api/analytics/use-build-tinybird-payload";
import { getMutationErrorMessage } from "@src/queryClient";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const fileExportExperience = async (
  data: FileExportExperienceFrontendRequestBodyType
) => {
  const resp = await api.post<FileExportExperienceResponseBodyType>(
    `/v2/experience/file-export`,
    data
  );
  return resp.data;
};

export const useFileExportExperience = (
  params: TinybirdExperimentAnalysisInput
) => {
  const buildTinybirdPayload = useBuildTinybirdPayload();

  return useMutation<
    FileExportExperienceResponseBodyType,
    Error,
    FileExportType
  >({
    mutationFn: async (exportType: FileExportType) =>
      fileExportExperience({
        ...buildTinybirdPayload.build(
          params,
          {
            datasetId: exportType,
            metrics: [],
          },
          "exports"
        ),
        exportType,
      }),
    onError: (error) => {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 503) {
          // Do nothing
        } else {
          const message = getMutationErrorMessage(error);
          if (message) {
            toast.error(message);
          }
        }
      }
    },
  });
};
